import {
  PluginSendBrokerQuoteApprovalEmailRequest,
  PluginSendBrokerQuoteApprovalEmailResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runSendBrokerQuoteApprovalEmail = (
  constructPost: ConstructPost,
  data: PluginSendBrokerQuoteApprovalEmailRequest,
): Promise<
  NonPaginatedResponse<PluginSendBrokerQuoteApprovalEmailResponse> | undefined
> =>
  constructPost<
    NonPaginatedResponse<PluginSendBrokerQuoteApprovalEmailResponse>
  >(
    `${PLUGIN_BASE_PATH}/send-broker-quote-approval-email`,
    { data },
    { preventDefaultErrorToast: true },
  );
